module.exports = __webpack_public_path__ + "img/ic_duvida.a468d1f2.svg";